import { render, staticRenderFns } from "./edutalk-payment-location.vue?vue&type=template&id=14219357&scoped=true"
import script from "./edutalk-payment-location.vue?vue&type=script&lang=js"
export * from "./edutalk-payment-location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14219357",
  null
  
)

export default component.exports